<template>
  <!--控球链 图表-->
  <div
    class="passing_distribution"
    :class="isAutoExportPng ? 'autoExportPng' : ''"
  >
    <div class="horizontal_box">
      <div
        class="echartsOneDom"
        v-show="echartType === 'one'"
        :style="{ height: `${pHeight}px` }"
      >
        <div class="passes" ref="passes">
          <!--canvas-->
        </div>
      </div>
    </div>
    <!-- <div @click="showBigImg" class="bigSqueen" v-if="tipFontFlag">
      <img src="./images/bigscore.png" alt="预览大图" />
    </div> -->
    <div class="tipDiv" v-show="tipFontFlag">
      <div class="tipMain">
        <div class="themeTip_area">
          <span class="themeTip_item">
            <span class="themeTip_text" v-text="`进球：`"></span>
            <span
              class="themeTip_val"
              v-text="_valPerFormatHandler(legendData.playerName)"
            ></span>
          </span>
          <span class="themeTip_item">
            <span class="themeTip_text" v-text="`助攻：`"></span>
            <span
              class="themeTip_val"
              v-text="_valPerFormatHandler(legendData.astPlayerName)"
            ></span>
          </span>
          <span class="themeTip_item">
            <span class="themeTip_text" v-text="`射门距离：`"></span>
            <span
              class="themeTip_val"
              v-text="_valPerFormatHandler(legendData.shotDistance, '米')"
            ></span>
          </span>
          <span class="themeTip_item">
            <span class="themeTip_text" v-text="`进球方式：`"></span>
            <span
              class="themeTip_val"
              v-text="_valPerFormatHandler(legendData.bodyPart)"
            ></span>
          </span>
        </div>
        <div class="iconTip_area">
          <span class="iconItem">
            <span class="iconImg"></span>
            <span class="iconText" v-text="'起点'"></span>
          </span>
          <span class="iconItem">
            <span class="iconImg"></span>
            <span class="iconText" v-text="'终点'"></span>
          </span>
        </div>
        <ul class="tipArrowUl">
          <li class="tipArrowli passTip">
            <i class="arrow_icon">
              <i class="arrow_before"></i>
              <i class="arrow_after"></i>
            </i>
            传球
          </li>
          <li class="tipArrowli dribbleTip">
            <i class="arrow_icon">
              <i class="arrow_before"></i>
              <i class="arrow_after"></i>
            </i>
            带球
          </li>
          <li class="tipArrowli shootOnTip">
            <i class="arrow_icon">
              <i class="arrow_before"></i>
              <i class="arrow_after"></i>
            </i>
            射门
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// 原点位于左上

import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
import datas from './ballControlChain.json'
import ballControlChainIcon from './ballControlChain_icon.js'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'ballControlChain',
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
          legendData: [],
        },
        statisticsModels: [],
      }),
    },
    tipFontFlag: {
      //控制是否显示 注解提示
      type: Boolean,
      default: false,
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
    // onResizeFlag: {
    //   //只要这个值一变化，这个组件的动态宽高及echarts都要重新计算
    // },
  },
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  data() {
    return {
      initFlag: false,
      echartData: null,
      echartType: '', //one: 横向； two:纵向 2列
      echartData_one: [],
      legendData: {},
      distanceToast: 0, //位移距离
      ballDisRatio: 0, //带球距离占比
      attackTime: 0, //进攻时间
      lt: {
        // 原点
        name: 'lt',
        x: 0,
        y: 0,
        symbolSize: 0, //大小
      },
      rb: {
        // 边界
        symbolSize: 20,
      },
      echartsArr: [], //
      links: [], // 箭头方向
      links_right: [], //2列 箭头方向
      linesData: [], // 散点位置
      linesData_right: [], //2列 右边散点位置
      symbolSize: 12, //小图的 散点大小
      symbolSizeToast: 24, //大图的 散点大小
      linesDataToast: [], //Toast 散点位置
      linesDataToast_right: [], //
      passBallColor: 'rgba(255, 255, 255, 1)', // 传球颜色
      shootInColor: 'rgba(235, 27, 80, 1)', // 射正颜色
      // shootScoreColor: '#A3D254', // 进球颜色
      // shootOutColor: '#DC5D6C', // 射偏/射中门框颜色
      // teamMemberColor: '#97DCC9', // 球员 圆圈颜色
      // teamMemberBorderColor: '#25AE87', // 球员 圆圈边框颜色
      // busColor: '#0D4236', // 替补颜色
      // busBorderColor: '#C87004', // 替补边框颜色
      lineWidth: 20, // 线条粗细
      solidType: 'solid', // 线条样式 "solid" "dashed" "dotted"
      dottedType: 'dotted',
      lineCurveness: 0, // 设置线条曲线 0-1
      lineOpacity: 1, // 透明度 0-1
      showToast: false,
      // proportion: this.$store.state.meter.PROPORTION, //足球场宽高比例 1.5
      proportion: 1.5,
      exportToastCanvasRate: 1.49, //大图 导出的图片的宽高比
      pWidth: null,
      pHeight: null,
      rotateWidth: null,
    }
  },
  watch: {
    datas(val) {
      if (this.initFlag) {
        this.filterData()
        this.initChart(this.$refs.passes, this.isAutoExportPng)
      }
    },
    // onResizeFlag(val) {
    //   this.$nextTick(() => {
    //     this.initDomWH()
    //     setTimeout(() => {
    //       this.echartDataArr.forEach((val) => {
    //         if (val.name === 'passes') {
    //           val.echarts.resize()
    //           return
    //         }
    //       })
    //     }, 10)
    //   })
    // },
  },
  created() {
    // this.datas = { ...datas }
  },
  mounted() {
    this.echartType = 'one'

    this.$nextTick(() => {
      this.initDomWH()
      this.filterData()
      setTimeout(() => {
        this.initFlag = true
        this.initChart(this.$refs.passes, this.isAutoExportPng)
      }, 10)
    })
  },
  methods: {
    initDomWH() {
      const smallDom = this.$refs.passes
      console.debug('isAutoExportPng:', this.isAutoExportPng)
      //横向一个
      this.pWidth = smallDom.clientWidth
      this.pHeight = Math.floor(this.pWidth / this.proportion)
      this.symbolSize = Math.ceil(Math.round(this.pWidth * 0.05 * 100) / 100)
      // this.pWidth = this.tipFontFlag ? this.mWidth - 100 :this.mWidth;  //100宽度 指的是右边的提示信息
    },
    initChart(passesRef, isAutoExportPng) {
      let linesData = []
      let name = ''

      name = this.echartType === 'one' ? 'passes' : 'passes_rotateLeft'

      let result = this.echartsArr.some((val) => {
        if (val.name === name) {
          return true
        }
      })

      console.debug('result', result)

      if (!result) {
        let Echart = this.$echarts.init(passesRef)
        this.echartsArr.push({
          name: name,
          refs: passesRef,
          echarts: Echart,
        })
        setTimeout(() => {
          Echart.resize()
        }, 0)
      }
      linesData = this.linesData
      // console.debug('linesData',linesData)
      let options = {
        animation: !isAutoExportPng,
        series: [
          {
            type: 'graph',
            layout: 'none',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            // symbolSize: 50,
            label: {
              show: false, // 圆圈里面的数字
            },
            edgeSymbol: ['none', 'arrow'],
            edgeSymbolSize: Math.ceil(this.symbolSize / 2.5),
            itemStyle: {
              //设置圆圈的阴影
              // shadowColor: 'rgba(0, 0, 0, 0.5)',
              // shadowBlur: 20
            },
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                global: false, // 缺省为 false
              },
            },
            // edgeLabel: {
            //   fontSize: 20,
            // },
            data: linesData,
            links: this.links,
          },
        ],
      }
      this.echartsArr.forEach((val, index) => {
        if (val.name === name) {
          console.debug('val.name:', val.name, 'name', name)
          val.echarts.setOption(options)
          // return
        }
      })
      console.debug('emitEventName:', isAutoExportPng)
      if (isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(
            this.$refs.passes,
            true,
            'uploadData',
            this.datas.data.legendData
          )
        }, 5 * 1000)
      }
    },
    filterData() {
      this.echartType = 'one'
      console.debug('this.echartType--1', this.echartType)
      let linksHold = []
      let oneAddArr = []
      let echartData_one = [].concat(this.datas.data.dataList)
      this.legendData =
        this.datas.data.legendData && this.datas.data.legendData[0]
          ? this.datas.data.legendData[0]
          : {}
      console.debug(echartData_one.length)
      console.debug('this.echartType--2', this.echartType, this.legendData)
      if (!echartData_one.length) {
        //数组里面为【】情况， 图表清空 return
        this.linesDataToast = []
        this.linesData = []
        this.links = []
      }
      console.debug('this.echartType--3', this.echartType)
      echartData_one.forEach((item, index) => {
        item.control_end = false
        if (item.chain_type == 3) {
          oneAddArr.push({
            index: index,
            obj: {
              control_end: true,
              chain_num: item.chain_num,
              player_id: 0,
              player_name: '',
              shirt_number: item.shirt_number,
              event_type: item.event_type,
              accurate_timestamp: '',
              start_x: item.end_x,
              start_y: item.end_y,
              end_x: 0,
              end_y: 0,
              chain_distance: 0,
              // dribbling_distance_percent: '',
              control_times: 0,
              chain_type: 2,
            },
          })
        }
      })
      console.debug('this.echartType--4', this.echartType)
      for (let i = oneAddArr.length; i > 0; i--) {
        echartData_one.splice(
          oneAddArr[i - 1].index + 1,
          0,
          oneAddArr[i - 1].obj
        )
        // echartData_one.push(oneAddArr[i-1].obj)
      }
      console.debug('this.echartType--5', this.echartType, echartData_one)
      let distanceToast = 0
      let ballDisRatio = 0
      let attackTime = 0
      echartData_one.forEach((item, index) => {
        item.controlIndex_name = index + ''
        if (item.chain_type != 3) {
          //最后射门的线不算到位移距离当中，同样带球距离占比也不算

          distanceToast += item.chain_distance - 0
        }
        attackTime += item.control_times - 0

        item.source = item.controlIndex_name
        item.target = item.control_end ? '' : index + 1 + ''
        let color = ''
        let lineType = this.solidType //默认是实线
        if (!item.control_end && item.chain_type == 3) {
          //第一个终止事件加样式，  这里默认只是射门终止事件，再判断是射正:in；射偏:out
          if (item.event_type == 15) {
            // color = this.shootInColor  //射正
            color = this.shootInColor
          } else if (item.event_type == 13 || item.event_type == 14) {
            // color = this.shootOutColor //射偏||射中门柱
            color = this.shootInColor
          } else if (item.event_type == 16 || item.event_type == 38) {
            // color = this.shootScoreColor //射进
            color = this.shootInColor
          } else {
            console.debug('event_type 数据异常')
          }
        } else {
          color = this.passBallColor
          if (item.chain_type == 1) {
            lineType = this.solidType
          } else if (item.chain_type == 2) {
            ballDisRatio += item.chain_distance - 0
            lineType = this.dottedType
          } else {
            console.debug('线的类型chain_type !== 1 || chain_type !== 2')
          }
        }

        // console.debug(index, lineType, color)
        linksHold.push({
          source: item.source, //箭头指向，起点
          target: item.target, //箭头指向，终点
          lineStyle: {
            //箭头和线的样式
            color: color, //箭头和线的颜色
            width: Math.ceil(this.symbolSize / 20),
            type: lineType,
            cap: 'round',
            join: 'round',
            opacity: this.lineOpacity,
          },
        })
      })
      console.debug('this.echartType--6', this.echartType)
      if (this.echartType === 'one') {
        this.distanceToast = Math.round(distanceToast * 10) / 10 //位移距离 小数点保留一位
        this.ballDisRatio = Math.round((ballDisRatio / distanceToast) * 100) //带球距离占比 小数点保留一位  是16%不是0.16%，所以不用/100
        this.attackTime = Math.floor(attackTime) //秒 只要整数
      }
      this.countLinesData(echartData_one)
      this.links = linksHold
    },
    countLinesData(chartsMap) {
      //设置运动员的位置
      const symbolSize = this.symbolSize
      let linesDataHold = []
      let chain_num = null //存储当前控球链的索引
      let width = null
      let height = null
      if (this.echartType === 'one') {
        width = this.pWidth
        height = this.pHeight
      } else {
        width = this.pHeight
        height = this.rotateWidth
      }
      linesDataHold.push(this.lt) // 固定原点
      chartsMap.forEach((item, index) => {
        // if (item.chain_type == 2) {
        //   //不显示队员图标的文字提示都需要隐藏
        //   item.showTeamFlag = false
        // } else {
        //   item.showTeamFlag = true
        // }

        let teamNumImgUlr = ''
        if (index == 0) {
          teamNumImgUlr = ballControlChainIcon.start_icon
        } else if (index == chartsMap.length - 2) {
          teamNumImgUlr = ballControlChainIcon.end_icon
        } else {
          teamNumImgUlr = ballControlChainIcon.pass_icon
        }
        if (chartsMap.length == 2) {
          teamNumImgUlr = ballControlChainIcon.end_icon
        }
        console.debug('teamNumImgUlr:', teamNumImgUlr)
        //按100x100算且预留四边空白区，左右边宽各2，上下边高各3；则起点坐标为（2,97）
        item.start_x = item.start_x - 0 > 100 ? 100 : item.start_x - 0
        item.start_y = item.start_y - 0 > 100 ? 100 : item.start_y - 0
        let x1 = 2,
          y1 = 3
        if (item.control_end) {
          //control_end=true：表示该item为控球链最后一个坐标点；由于数据要画到四边空白区里的球场中，所以按照下面x,y的换算方法，队员圆圈永远不会出球场，而射门那条线需要画到球场外，所以在这里单加一个逻辑，把射门的线延长出去
          if (item.start_x > 50 || item.start_y > 50) {
            // 右半场的线
            x1 = 6 //2+2
            y1 = 6 //3+3
          } else {
            // 左半场的线
            x1 = 0
            y1 = 0
          }
        }
        linesDataHold.push({
          name: item.controlIndex_name,
          x: Math.round((width / 100) * (item.start_x * 0.96 + x1) * 100) / 100,
          y:
            Math.round(
              (height / 100) * (100 - item.start_y * 0.94 - y1) * 100
            ) / 100,
          value: [item.shirt_number],
          // symbol: item.showTeamFlag ? teamNumImgUlr : 'none',
          symbol: !item.control_end ? teamNumImgUlr : 'none',
          symbolSize: symbolSize,
          label: {
            // color: 'transparent',
            // show: item.showTeamFlag ? true : false,
            show: !item.control_end ? true : false,
            formatter: '{@[0]}',
            fontWeight: 'bold',
            fontSize: Math.ceil(symbolSize / 1.5),
            fontFamily: 'Qatar2022',
            color: 'rgba(253, 246, 129, 1)',
          },
        })
      })
      linesDataHold.push({
        // 设置当前边界值
        name: 'rb',
        x: width,
        y: height,
        value: [0],
        symbolSize: 0,
      })

      this.linesData = linesDataHold
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    // resize(index) {

    //     console.debug(this.echartsArr)
    //     this.echartsArr[index].echarts.resize()
    // },
  },
  beforeDestroy() {
    //性能优化，防止溢出
    this.echartsArr.forEach((val, index) => {
      // removeListener(val.refs, this.resize(index)) //销毁监听事件
      val.echarts.dispose() //销毁echarts实例，防止内侧泄露
    })

    this.echartsArr = []
  },
}
</script>

<style lang="scss" scoped>
.passing_distribution {
  position: relative;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  width: 98%;
  height: auto;
  &.autoExportPng {
    width: 100%;
    .horizontal_box {
      width: 100%;
      border: 0;
      background: transparent;
      border-radius: 0;
    }
  }
  .horizontal_box {
    width: 100%;
    border: 0.416vw solid var(--mixtmt_echarts_footBallPlaygroundColor);
    background: var(--mixtmt_echarts_footBallPlaygroundColor);
    border-radius: 0.694vw;
    .echartsOneDom {
      width: 100%;
      .passes {
        flex: 1;
        width: 100%;
        height: 100%;
        background-color: var(--mixtmt_echarts_footBallPlaygroundBgColor);
        background-image: var(--mixtmt_ball_bg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
      .bigSqueen {
        width: 1.11vw;
        height: 1.11vw;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .tipDiv {
    /* position: absolute;
    bottom: 50%;
    right: 0;
    z-index: 2;
    transform: translate(100%, -50%); */
    .tipMain {
      height: auto;
      position: relative;
    }
  }
  .iconTip_area,
  .themeTip_area {
    width: 8.033vw;
    padding: 0.2vw 0.3vw;
    margin: 0 0 0.3vw 0.3vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--mixtmt_echarts_footBallPlaygroundColor);
    border-radius: 0.3vw;
    .iconItem {
      width: 100%;
      height: 2vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      &:first-child {
        .iconImg {
          background-image: var(--mixtmt_shotChain_start_icon);
        }
      }
      &:nth-child(2) {
        .iconImg {
          background-image: var(--mixtmt_shotChain_end_icon);
        }
      }
      .iconImg {
        width: 1.5vw;
        height: 1.5vw;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
      .iconText {
        padding-left: 0.2vw;
        line-height: 2vw;
        font-size: 0.833vw;
        text-align: left;
        color: #000000;
      }
    }
  }
  .themeTip_area {
    flex-direction: column;
    align-items: flex-start;
    .themeTip_item {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      width: 100%;
      padding-bottom: 0.5vw;
      .themeTip_text {
        padding-left: 0.2vw;
        line-height: 1.28vw;
        font-size: 0.833vw;
        text-align: left;
        color: #000000;
        font-weight: bold;
      }
      .themeTip_val {
        padding-left: 0.2vw;
        line-height: 1.28vw;
        font-size: 0.833vw;
        text-align: left;
        color: #000000;
      }
    }
  }
  .tipArrowUl {
    width: 8.033vw;
    padding: 0.2vw 0.3vw;
    margin: 0 0 0.3vw 0.3vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--mixtmt_echarts_footBallPlaygroundColor);
    border-radius: 0.3vw;
    .tipArrowli {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: auto;
      flex: 1;
      padding-left: 0.2vw;
      line-height: 2vw;
      font-size: 0.833vw;
      text-align: left;
      color: #000000;
    }
  }

  .arrow_icon {
    position: absolute;
    left: 0.2vw;
    top: 0.15vw;
    z-index: 2;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .arrow_before {
      height: 1.5vw;
      width: 1px;
    }
    .arrow_after {
      width: 0;
      height: 0;
      border-left: 0.347vw solid transparent; /* left arrow slant */
      border-right: 0.347vw solid transparent; /* right arrow slant */
      font-size: 0;
      line-height: 0;
      transform: translate(-55%, -120%);
    }
  }
  .passTip {
    .arrow_icon {
      .arrow_before {
        background-color: #000000;
      }
      .arrow_after {
        border-bottom: 0.486vw solid #000000;
      }
    }
  }
  .dribbleTip {
    .arrow_icon {
      .arrow_before {
        border-left: 1px dashed #000000;
      }
      .arrow_after {
        border-bottom: 0.486vw solid #000000;
      }
    }
  }
  .shootOnTip {
    .arrow_icon {
      /* top: 8%; */
      .arrow_before {
        background-color: rgba(235, 27, 80, 1);
      }
      .arrow_after {
        border-bottom: 0.486vw solid rgba(235, 27, 80, 1);
      }
    }
  }
}
</style>
